import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { BrowserRouter as Router } from "react-router-dom";
import "./css/custom.css";
import { i18nFactory } from "./literals";
import { Global } from "./contexts/Global";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const i18n = i18nFactory({ lang: "es-ES" });


ReactDOM.render(
  <React.StrictMode>
    <Global.Provider value={{i18n}}>
      <Router>
        <App />
      </Router>
    </Global.Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
